<template>
  <div class="leaderboard">
    <header-title title="LEADERBOARD" />
    <div class="sl-panel sl-scroll-x">
      <table class="sl-table">
        <thead>
          <tr>
            <th class="col-rank">#</th>
            <th>User</th>
            <th
              class="col-num is-sortable"
              :class="{ 'is-sorted': order === 'balance' }"
              @click="orderBy('balance')"
            >Swiftbucks</th>
            <th
              class="col-num is-sortable"
              :class="{ 'is-sorted': order === 'watchTime' }"
              @click="orderBy('watchTime')"
            >Watch Time (minutes)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(leader, index) in currentLeaders" v-bind:key="leader.user_id.toString()">
            <td class="col-rank rank">{{ index + 1 }}</td>
            <td data-title="User" class="user-cell">
              <User :user_id="leader.user_id"></User>
            </td>
            <td data-title="Swiftbucks" class="col-num sl-num">{{formatCurrency(leader.total)}}</td>
            <td data-title="WatchTime" class="col-num">{{formatCurrency(leader.minutes)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'bets',
  async created () {
    this.$store.dispatch('fetchBalanceLeaderboard')
    this.$store.dispatch('fetchWatchTimeLeaderboard')
  },
  data () {
    return {
      order: 'balance'
    }
  },
  computed: Object.assign(mapState([
    // map this.count to store.state.count
    'watchTimeLeaderboard',
    'balanceLeaderboard'
  ]), {
    currentLeaders () {
      return this.order === 'balance' ? this.balanceLeaderboard : this.watchTimeLeaderboard
    }
  }),
  methods: {
    orderBy (ob) {
      this.order = ob
    }
  }
}
</script>

<style scoped>
.sl-table {
  min-width: 640px;
}

.col-rank {
  width: 64px;
  text-align: center;
}

.rank {
  font-family: var(--sl-font-display);
  font-size: 18px;
  color: var(--sl-faint);
}

.col-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.is-sortable {
  cursor: pointer;
}

.is-sortable:hover {
  color: #ffe2e3;
}

.is-sorted::after {
  content: ' \25BE';
}

.user-cell {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Leaderboard.vue